import React, { useState } from 'react';
import { globalSearchMailers } from './constants/globalSearch';
import { sortByAlpha } from '../../helpers/sorters';
import { canWrite } from '../../helpers/rolePermissions';
import FormSubmissionsSearch from './FormSubmissionsSearch';

const ContainerSearchItem = ({ container, value, authorized }) => {
  const [mailers, setMailers] = useState([]);
  const [mailersLoaded, setMailersLoaded] = useState(false);
  const [userCanWrite, setUserCanWrite] = useState(false);
  const [hide, setHide] = useState(true);
  const showForms = container.forms.length > 0 && !hide;

  const loadMailers = async (container_id) => {
    let params = {
      id: container_id,
      form_ids: container.forms.map((f) => f.id),
    };
    let result = await globalSearchMailers(params);
    if (result.ok) {
      setMailers(sortByAlpha(result.data.mailers, 'name'));
      setUserCanWrite(canWrite(result.data.user_permission));
      setMailersLoaded(true);
    }
  };

  const handleExpand = (e) => {
    if (!mailersLoaded) {
      loadMailers(container.id);
    }
    setHide(!hide);
  };

  return (
    <div className='container-search-item '>
      <h3>
        {container.name}{' '}
        {authorized ? (
          <div
            className='right'
            id={`expand-${container.id}`}
            onClick={handleExpand}
            style={{ cursor: 'pointer' }}
          >
            {hide ? (
              <i className='fa-solid fa-magnifying-glass-plus' title='Expand' />
            ) : (
              <i className='fa-solid fa-magnifying-glass-minus' title='Hide' />
            )}
            <span>{hide ? ' Expand ' : ''}</span>
          </div>
        ) : (
          <div className='right'>Unauthorized</div>
        )}
      </h3>
      <p>
        {container.forms.length} {container.forms.length > 1 ? 'Forms' : 'Form'}{' '}
        containing response "{value}"
      </p>
      {showForms &&
        container.forms.map((form) => (
          <FormSubmissionsSearch
            form={form}
            key={`f-${form.id}`}
            mailers={mailers.filter((m) => m.form_id == form.id)}
            userCanWrite={userCanWrite}
          />
        ))}
    </div>
  );
};

export default ContainerSearchItem;
